import React from 'react';

type RecursiveMapTarget = null|string|String|React.ReactNode|RecursiveMapTarget[];

export default class TextUtility {
  private static recursiveMap(value: RecursiveMapTarget, callback: (value: string) => RecursiveMapTarget): RecursiveMapTarget {
    if (value === null) {
      return null;
    } if (typeof value === 'string' || value instanceof String) {
      return callback(value.toString());
    } if (Array.isArray(value)) {
      return value.map((child) => this.recursiveMap(child, callback));
      // } else if (React.isValidElement(value)) {
      //   return React.Children.map(value, (child) => {
      //     this.recursiveMap(child, callback);
      //   });
    }
    return value;
  }

  /**
   */
  static nl2br(text: React.ReactNode): React.ReactNode {
    return this.recursiveMap(text, (subtext) => {
      const regexp = /(\r\n|\r|\n)/g;
      return subtext.split(regexp).map((part, index) => {
        if (part.match(regexp)) {
          // eslint-disable-next-line react/no-array-index-key
          return (<br key={index} />);
        }
        return part;
      });
    });
  }

  /**
   */
  static autoLink(text: React.ReactNode): React.ReactNode {
    return this.recursiveMap(text, (subtext) => {
      const regexp = /(https?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+)/g;
      return subtext.split(regexp).map((part, index) => {
        if (part.match(regexp)) {
          // eslint-disable-next-line react/no-array-index-key
          return (<a href={part} key={index} target="_blank" rel="noopener noreferrer">{part}</a>);
        }
        return part;
      });
    });
  }

  static mask(text: string|null|undefined, character: string): string {
    if (text === null || typeof text === 'undefined') return '';
    const masks: string[] = [];
    while (masks.length < text.length) {
      masks.push(character);
    }
    return masks.join('');
  }
}
